import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel, StatCard, StatusBadge, Empty } from "@/components/crm/common";
import { DataTable } from "@/components/crm/DataTable";

export function AccessSummary() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/hub/access-summary").then((r) => setD(r.data)).catch(() => setD({ roles: [], users: [] })); }, []);
  if (!d) return <Panel><Empty text="Loading…" /></Panel>;
  const mods = [...new Set(d.roles.flatMap((r) => Object.keys(r.modules)))].sort();
  return (
    <>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <StatCard testid="access-stat-users" label="CRM logins" value={d.users.length} />
        <StatCard testid="access-stat-active" label="Active" value={d.users.filter((u) => !u.disabled).length} />
        <StatCard testid="access-stat-pending" label="Never logged in yet" value={d.users.filter((u) => u.pending_first_login).length} />
        <StatCard testid="access-stat-roles" label="Roles" value={d.roles.length} />
      </div>
      <Panel testid="access-role-matrix" title="What each role can do (V view · C create · E edit · A approve)">
        <div className="thin-scroll overflow-x-auto">
          <table className="w-full text-xs">
            <thead><tr><th className="sticky left-0 bg-white px-2 py-2 text-left text-[#C5A46D]">Role</th>{mods.map((m) => <th key={m} className="px-1.5 py-2 text-[10px] font-bold uppercase text-zinc-500">{m}</th>)}</tr></thead>
            <tbody>{d.roles.map((r) => (
              <tr key={r.name} className="border-t border-zinc-100">
                <td className="sticky left-0 whitespace-nowrap bg-white px-2 py-2 font-bold text-zinc-900">{r.name} <span className="font-normal text-zinc-500">· {r.users} users</span></td>
                {mods.map((m) => <td key={m} className="px-1.5 py-2 text-center font-mono font-bold text-[#C5A46D]">{r.modules[m] || <span className="text-zinc-300">–</span>}</td>)}
              </tr>
            ))}</tbody>
          </table>
        </div>
      </Panel>
      <Panel testid="access-team" title="Team access">
        <DataTable testid="access-users-table" rows={d.users} columns={[
          { key: "name", label: "Name", render: (u) => <span className="font-bold">{u.name}</span> }, { key: "email", label: "Login email" }, { key: "role", label: "Role" },
          { key: "status", label: "Status", render: (u) => <StatusBadge value={u.disabled ? "Disabled" : u.pending_first_login ? "Pending first login" : "Active"} /> },
        ]} />
      </Panel>
    </>
  );
}
